import styled from 'styled-components';

interface Props {
  pathname: string;
}

export const Container = styled.div<Props>`
  display: flex;
  align-items: center;

  .user-box__bell-container{

    ${({ pathname }) => {
      if (pathname === '/') {
        return `
          > svg {
            fill: var(--blue00);
          }
        `;
      } else {
        return `
          > svg {
            fill: #fff;
          }
        `;
      }
    }}

    background: transparent;
    border: none;
  }

  .user-box-wrapper{
    width: fit-content;
    height: fit-content;
    margin-left: 32.9px;

    position: relative;
    z-index: 2;
  }

  @media (max-width: 1080px) {
    position: unset;
  }

  @media (max-width: 629px) {
    .user-box-wrapper{
      margin-left: 15px;
    }
  }
`;

export const SignInSelect = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 24.4px 5px 7px;

  width: fit-content;
  height: 50px;

  color: #fff;

  border-radius: 50px;
  background: linear-gradient(to right, #acd7ff, var(--blue12));

  .signin-select__profile-wrapper{
    width: fit-content;
    height: fit-content;

    border: 0;
    outline: none;
    background-color: transparent;
    cursor: pointer;
  }

  .signin-select__profile-icon {
    width: 43px;
    height: 43px;

    object-fit: cover;
    border-radius: 50%;
    vertical-align: middle;
  }

  .signin-select__profile-action {
    width: 100%;
    max-width: 50px;
    margin-left: 18px;

    color: #fff;
    font-size: 1.125rem;
    vertical-align: middle;
  }

  .signin-select__profile-divider {
    height: 21px;
    margin-left: 37.3px;

    border-left: 1px solid #fff;
  }

  .signin-select__chevron-button{
    margin-left: 51.3px;

    border: 0;
    background-color: transparent;
    cursor: pointer;
  }

  .user-box__menu,
  .menu--closed{
    width: 100%;

    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    z-index: -1;
    overflow: hidden;

    background-color: var(--blue00);
    border-radius:  0 0 20px 20px;
    transition: height 0.2s ease, padding 0.2s ease;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.30);
  }

  .user-box__menu{
    height: 400px;
    padding-top: 50px;
  }

  .menu--closed{
    height: 0;
    padding-top: 0;
  }

  .user-box__menu-link,
  .user-box__menu-exit-text{
    width: 100%;
    padding: 0 30px;
    margin-bottom: 18px;
    display: block;
  }

  .user-box__menu-link,
  .user-box__menu-exit-text{
    color: #fff;
    font-size: 1rem;
  }

  .user-box__menu-exit{
    width: fit-content;
    height: fit-content;

    display: none;

    background-color: transparent;
    border: 0;
  }

  .user-box__menu-exit-text{
    font-weight: bold;
  }

  .user-box__social-container{
    width: 80%;
    height: fit-content;
    margin: 20px auto 0;

    display: flex;
    flex-direction: column;
    gap: 8px
  }

  .user-box__menu-social{
    width: 32.32px;
    height: 32.32px;

    border-radius: 50%;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover{
      transform: scale(1.1);
    }
  }

  .user-box__social-img{
    width: 100%;
    height: 100%;

    object-fit: cover;
  }

  @media (max-width: 629px) {
    .signin-select__profile-divider{
      margin-left: 15px;
    }
    .signin-select__profile-action{
      display: none;
    }
    .signin-select__chevron-button{
      margin-left: 15px;

      border: 0;
      background-color: transparent;
      cursor: pointer;
    }

    .user-box__menu{
      height: 500px;
    }

    .user-box__menu-exit{
      display: block;
    }
  }
`;
